import { getGlobalSelector } from './mmd';

const getRoot = () => getGlobalSelector().additionalSelectors.navigationCardSelectors;

export const getNextCardDetails = (state: any) => getRoot().getNextCardDetails(state);

export const getNextStepInfo = (state: any) => (getRoot().getNextStepInfo ? getRoot().getNextStepInfo(state) : null);
export const getPrevStepInfo = (state: any) => (getRoot().getPrevStepInfo ? getRoot().getPrevStepInfo(state) : null);
